import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b2c5b048"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item_div" }
const _hoisted_2 = { class: "row_item_div" }
const _hoisted_3 = ["onClick"]

import { useI18n } from 'vue-i18n'
import { PresetChartType } from '@/types/slides'


export default /*#__PURE__*/_defineComponent({
  __name: 'ChartStack',
  emits: ["select"],
  setup(__props, { emit }: { emit: ({
  (event: 'select', payload: PresetChartType): void
}), expose: any, slots: any, attrs: any }) {

const { t, locale } = useI18n()



const chartList: PresetChartType[] = ['bar', 'horizontalBar', 'line', 'area', 'scatter', 'pie', 'ring']

const selectChart = (chart: PresetChartType) => {
  emit('select', chart)
}


return (_ctx: any,_cache: any) => {
  const _component_IconChartLine = _resolveComponent("IconChartLine")!
  const _component_IconChartHistogram = _resolveComponent("IconChartHistogram")!
  const _component_IconChartPie = _resolveComponent("IconChartPie")!
  const _component_IconChartHistogramOne = _resolveComponent("IconChartHistogramOne")!
  const _component_IconChartLineArea = _resolveComponent("IconChartLineArea")!
  const _component_IconChartRing = _resolveComponent("IconChartRing")!
  const _component_IconChartScatter = _resolveComponent("IconChartScatter")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", null, _toDisplayString(_unref(t)(`editor.canvasTool.index.chart`)), 1),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(chartList, (chart, index) => {
          return _createElementVNode("div", {
            class: "stack_div",
            key: index,
            onClick: ($event: any) => (selectChart(chart))
          }, [
            (chart === 'line')
              ? (_openBlock(), _createBlock(_component_IconChartLine, {
                  key: 0,
                  size: "24"
                }))
              : (chart === 'bar')
                ? (_openBlock(), _createBlock(_component_IconChartHistogram, {
                    key: 1,
                    size: "24"
                  }))
                : (chart === 'pie')
                  ? (_openBlock(), _createBlock(_component_IconChartPie, {
                      key: 2,
                      size: "24"
                    }))
                  : (chart === 'horizontalBar')
                    ? (_openBlock(), _createBlock(_component_IconChartHistogramOne, {
                        key: 3,
                        size: "24"
                      }))
                    : (chart === 'area')
                      ? (_openBlock(), _createBlock(_component_IconChartLineArea, {
                          key: 4,
                          size: "24"
                        }))
                      : (chart === 'ring')
                        ? (_openBlock(), _createBlock(_component_IconChartRing, {
                            key: 5,
                            size: "24"
                          }))
                        : (chart === 'scatter')
                          ? (_openBlock(), _createBlock(_component_IconChartScatter, {
                              key: 6,
                              size: "24"
                            }))
                          : _createCommentVNode("", true)
          ], 8, _hoisted_3)
        }), 64))
      ])
    ])
  ]))
}
}

})